<template>
  <div class="search-page">
    <div class="module-content-border">
      <div class="main-content">
        <div class="page-title">
          <p class="title-text">搜索结果</p>
          <span class="text-en">SEARCH RESULT</span>
        </div>
        <div class="search-box">
          <input type="text" placeholder="搜索" v-model="searchText" @keydown.enter.prevent="pageChange(1)">
          <span class="handle-search" @click="pageChange(1)">搜索</span>
        </div>
        <p class="search-result-text">找到了{{ total }}个结果</p>
      </div>
    </div>
    <div class="main-content">
      <p class="con-title">搜索类型-页面</p>
      <template v-if="total > 0">
        <ul class="search-result-con">
          <template v-for="(item) in searchList">
            <li class="result-item" :key="item.link_id" @click="toDetail(item)">
              {{ item.title }}
            </li>
          </template>
        </ul>
      </template>
      <template v-if="total === 0">
        <el-empty description="搜索结果为空"></el-empty>
      </template>
    </div>
    <div class="paging-box">
      <pagingEl :current-page="page" :total="total" :page-size="size" @currentChange="pageChange"/>
    </div>
  </div>
</template>

<script>
import pagingEl from "@/components/pagingEl";
import {searchResults} from "@/request/api";

export default {
  name: "search",
  components:{
    pagingEl
  },
  data() {
    return {
      searchList:[],
      searchText: '',
      page:0,
      size:20,
      total: 0,
    }
  },
  computed: {},
  created() {
    this.initSearchText()
    this.searchResult()
  },
  mounted() {
  },
  methods: {
    initSearchText(){
      const {searchText} = this.$route.query;
      this.searchText = searchText
    },
    searchResult(){
      const {page,size,searchText} = this
      const requestData = {
        page,
        size,
        keywords:searchText
      }
      searchResults(requestData).then(res=>{
        let resData = res.data;
        this.total = Number(resData.paging.recordCount);
        this.searchList = resData.res
      })
    },
    pageChange(e){
      this.page = e;
      this.searchResult()
    },
    toDetail(item){
      if(item.type === 1){
        this.$router.push({name:'newsDetail',query:{id:item.link_id}})
      }else if(item.type === 2){
        this.$router.push({name:'worksDetail',query:{id:item.link_id}})
      }
    }
  },
  watch:{
    $route() {
      this.initSearchText()
      this.searchResult()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/css/_var.scss";
  .search-page {
    background-color: #fff;
    padding-bottom: 120px;
    .search-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 630px;
      margin: 33px auto 0;
      font-size: 25px;
      font-weight: bold;
      height: 62px;
      & > input {
        display: block;
        width: 483px;
        height: 62px;
        border: 1px solid $blockColor--1;
        padding-left: 20px;
      }
      .handle-search {
        display: block;
        width: 126px;
        cursor: pointer;
        font-size: 24px;
        color: #fff;
        font-weight: bold;
        text-align: center;
        line-height: 62px;
        background-color: $bgColor-2;

      }
    }
    .search-result-text {
      font-size: 25px;
      padding: 25px 0 30px;
      font-weight: bold;
      text-align: center;
    }
    .con-title {
      width: 630px;
      margin: 0 auto;
      font-size: 25px;
      font-weight: bold;
      padding-top: 35px;
    }
    .search-result-con {
      width: 630px;
      margin: 0 auto;
      font-size: 24px;
      font-weight: 400;
      padding: 0 36px 0 60px;
      border-bottom: 1px solid $blockColor--1;
      .result-item {
        width: 100%;
        padding: 12px 0;
        line-height: 1.5;
        position: relative;
        border-bottom: 1px solid $blockColor--1;
        cursor: pointer;
        &:nth-last-of-type(1){
          border-bottom: none;
        }
        &::before {
          display: block;
          content: '';
          width: 10px;
          height: 10px;
          background-color: #000;
          position: absolute;
          left: -25px;
          top: 30px;
          transform: translateY(-50%);
        }
      }
    }
  }
  .paging-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 90px;
  }
</style>
